import React from 'react';

export default function PaymentIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="Payments"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="ic/credit_card">
          <g>
            <mask id="mask-2-payment" fill="white">
              <path
                d="M20,4 L4,4 C2.89,4 2.01,4.89 2.01,6 L2,18 C2,19.11 2.89,20 4,20 L20,20 C21.11,20 22,19.11 22,18 L22,6 C22,4.89 21.11,4 20,4 Z M20,18 L4,18 L4,12 L20,12 L20,18 Z M20,8 L4,8 L4,6 L20,6 L20,8 Z"
                id="path-1"></path>
            </mask>
            <g id="Shape" fillRule="nonzero"></g>
            <g id="Red-/-R300" mask="url(#mask-2-payment)" fill="#FF5630">
              <rect id="R300" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
